'use client';

// react
import { useMemo, useState } from 'react';
// @mui
import { Container, Stack } from '@mui/material';
// components
import ContentsNavigation from '@/components/common/contents-navigation';
import SearchBar, { SEARCH_BY_TYPE } from '@/components/common/SearchBar';

type Props = {
  type: 'events' | 'services' | 'programs' | 'products';
};

export default function ContentsSearchBar({ type }: Props) {
  const [search, setSearch] = useState('');

  const typeObject = useMemo(() => {
    switch (type) {
      case 'events':
        return {
          header: 'Explore Events',
          placeholder: 'Search for events',
        };
      case 'services':
        return {
          header: 'Explore One on Ones',
          placeholder: 'Search for one on ones',
        };
      case 'programs':
        return {
          header: 'Explore Programs',
          placeholder: 'Search for programs',
        };
      case 'products':
        return {
          header: 'Explore Products',
          placeholder: 'Search for products',
        };
    }
  }, [type]);

  const { header, placeholder } = typeObject ?? {};

  return (
    <Container maxWidth="lg">
      <Stack direction="row" spacing={0}>
        <SearchBar
          setSearch={setSearch}
          search={search}
          header={header ?? ''}
          placeholder={placeholder ?? ''}
          type={type}
          searchByType={SEARCH_BY_TYPE.CONTENT}
        />
      </Stack>

      <ContentsNavigation />
    </Container>
  );
}
